import { initializeApp } from "firebase/app";
import { getFirestore, updateDoc } from "firebase/firestore";
import { doc, setDoc } from "firebase/firestore";
import { collection, addDoc } from "firebase/firestore";

import { doc, getDoc } from "firebase/firestore";
import { collection, getDocs } from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  getMetadata,
  listAll,
  getDownloadURL,
  listAll,
} from "firebase/storage";
import { RESULT_PER_PAGE } from "./config";

const config = {
  apiKey: "AIzaSyCCmXo14Rhqc7dDRhTYTt2kb6vR22kkj3g",
  authDomain: "relationship-and-reality.firebaseapp.com",
  projectId: "relationship-and-reality",
  storageBucket: "relationship-and-reality.appspot.com",
  messagingSenderId: "1032798662799",
  appId: "1:1032798662799:web:a9a789aa0c7f91639600fa",
  measurementId: "G-Q9FGXNRTHN",
};

const app = initializeApp(config);
const db = getFirestore(app);
const auth = getAuth();
const storage = getStorage(app);

export const state = {
  blogs: [],
  page: 1,
  updated: [],
  dataBlog: [],
};

export const writeData = async function (data) {
  try {
    const docRef = await addDoc(collection(db, "post"), data);
    console.log(docRef);
    return docRef;
  } catch (error) {
    console.log(error);
  }
};

export const getBlog = async function (id) {
  const docRef = doc(db, "post", id);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    console.log("No such document!");
  }
};
export const update = async function (id) {
  try {
    const docRef = doc(db, "post", id);
    const data = {
      uid: id,
      time: new Date().getTime(),
    };

    updateDoc(docRef, data)
      .then((docRef) => {
        console.log(
          "A New Document Field has been added to an existing document"
        );
      })
      .catch((error) => {
        console.log(error);
      });
  } catch (error) {
    console.log(error);
  }
};
export const storeComment = async function (data) {
  const washingtonRef = doc(db, "post", data.uid);
  await updateDoc(washingtonRef, {
    commentData: data.commentData,
  });
};

export const uploadImage = async function (file, id) {
  try {
    const imagesRef = ref(storage, "images");
    const storageRef = ref(storage, `images/${id}`);

    const metadata = {
      contentType: file.type,
    };

    const uploadTask = uploadBytes(storageRef, file, metadata);
  } catch (error) {
    console.log(error);
  }
};

export const getImage = async function () {
  try {
    const listRef = ref(storage, "images");

    const list = await listAll(listRef);
    const data = list.items.map(async (refPoint) => {
      const url = await refPoint.fullPath;

      const starsRef = ref(storage, url);
      const download = await getDownloadURL(starsRef);

      const id = url.split("/")[1];

      return [
        {
          url: download,
          id: url,
        },
      ];
    });

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getData = async function () {
  const querySnapshot = await getDocs(collection(db, "post"));
  querySnapshot.forEach((doc) => {
    state.blogs.push({
      [doc.id]: doc.data(),
    });
  });

  return state.blogs;
};

export const getResultPerpAGE = function (data, page) {
  let start = (page - 1) * RESULT_PER_PAGE;
  let end = page * RESULT_PER_PAGE;

  return data.slice(start, end);
};

export const signIn = async function (email, password) {
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    const user = userCredential.user;
    return user;
  } catch (error) {
    const errorCode = error.code;
    const errorMessage = error.message;

    alert(errorMessage);
  }
};
export const timeAgo = (date) => {
  const seconds = Math.floor((new Date() - date) / 1000);

  let interval = Math.floor(seconds / 31536000);
  if (interval > 1) {
    return interval + " years ago";
  }

  interval = Math.floor(seconds / 2592000);
  if (interval > 1) {
    return interval + " months ago";
  }

  interval = Math.floor(seconds / 86400);
  if (interval > 1) {
    return interval + " days ago";
  }

  interval = Math.floor(seconds / 3600);
  if (interval > 1) {
    return interval + " hours ago";
  }

  interval = Math.floor(seconds / 60);
  if (interval > 1) {
    return interval + " minutes ago";
  }

  if (seconds < 10) return "just now";

  return Math.floor(seconds) + " seconds ago";
};
